import React from 'react';
import WelcomeSheet from './welcome/WelcomeSheet';
import ShareIntroBlock from './welcome/ShareIntroBlock';
import HomeInstallNudgeBlock from './welcome/HomeInstallNudgeBlock';
import HomeInstallDetailBlocks from './welcome/HomeInstallDetailBlocks';
import WelcomeButton from './welcome/WelcomeButton';
import { useHomeInstallNudge } from './welcome/useHomeInstallNudge';
import type { TopicWelcomeProps } from './welcome/types';

/**
 * The standard welcome sheet a visitor sees on arriving at a topic: who shared
 * it, the Home-Screen install nudge, and the button that drops them into the
 * topic. Rendered by the classic read view for every type.
 *
 * With the topic garden on, each type dispatches to its own
 * `topic_garden/<type>/WelcomeInterstitial.tsx` instead, which composes the
 * same blocks from `./welcome/` and may diverge freely.
 */
const WelcomeInterstitial: React.FC<TopicWelcomeProps> = ({
  isOpen,
  topicType,
  senderName,
  onDismiss,
  hideShareIntro = false,
  isUpdate = false,
}) => {
  const homeInstall = useHomeInstallNudge(isOpen);

  return (
    <WelcomeSheet
      isOpen={isOpen}
      onDismiss={onDismiss}
      compact={!homeInstall.show}
    >
      {!hideShareIntro && (
        <ShareIntroBlock
          topicType={topicType}
          senderName={senderName}
          isUpdate={isUpdate}
        />
      )}

      {homeInstall.show && (
        <HomeInstallNudgeBlock
          dismissed={homeInstall.dismissed}
          onDismissedChange={homeInstall.onDismissedChange}
        />
      )}

      <WelcomeButton onClick={onDismiss} />

      {homeInstall.show && <HomeInstallDetailBlocks />}
    </WelcomeSheet>
  );
};

export default WelcomeInterstitial;
